// @ts-nocheck
import parseQueryString from "@insite/client-framework/Common/Utilities/parseQueryString";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getLocation } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import constants from "@store/constants";
import TaxExemptionCertificateForm from "@store/Library/Components/TaxExemptionCertificateForm";
import { usePageLinkByPageType } from "@toolkit/Framework/Store/Links/LinksHooks";
import React from "react";
import { connect } from "react-redux";

const enum fields {
    submitButtonText = "submitButtonText",
    successMessage = "successMessage",
    fileImportFormat = "fileImportFormat",
    financeCompanyRequired = "financeCompanyRequired",
    messageRequired = "messageRequired",
    firstNameRequired = "firstNameRequired",
    lastNameRequired = "lastNameRequired",
    fileRequired = "fileRequired",
    isFinanceCompanyDropdown = "isFinanceCompanyDropdown",
    allowMultipleFiles = "allowMultipleFiles",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.submitButtonText]: string;
        [fields.successMessage]: string;
        [fields.fileImportFormat]: string;
        [fields.financeCompanyRequired]: boolean;
        [fields.messageRequired]: boolean;
        [fields.firstNameRequired]: boolean;
        [fields.lastNameRequired]: boolean;
        [fields.fileRequired]: boolean;
        [fields.isFinanceCompanyDropdown]: boolean;
        [fields.allowMultipleFiles]: boolean;
    };
}

const mapStateToProps = (state: ApplicationState) => ({
    queryParams: parseQueryString<{ returnPage?: string }>(getLocation(state).search),
});

type Props = OwnProps & ReturnType<typeof mapStateToProps>;

interface TECSubmitNewFormStyles {}

const tecSubmitNewFormStyles: TECSubmitNewFormStyles = {};

const styles = tecSubmitNewFormStyles;

const TECSubmitNewForm = ({
    fields: {
        fileImportFormat,
        successMessage,
        submitButtonText,
        financeCompanyRequired,
        isFinanceCompanyDropdown,
        messageRequired,
        firstNameRequired,
        lastNameRequired,
        fileRequired,
        allowMultipleFiles = false,
    },
    queryParams: { returnPage },
}: Props) => {
    const linkBack = returnPage
        ? usePageLinkByPageType(returnPage)
        : usePageLinkByPageType(constants.pageType.taxExemptionCertificates);

    return (
        <TaxExemptionCertificateForm
            id="tecNewCertificateForm"
            formVariant="new"
            fileImportFormat={fileImportFormat}
            financeCompanyRequired={financeCompanyRequired}
            isFinanceCompanyDropdown={isFinanceCompanyDropdown}
            messageRequired={messageRequired}
            firstNameRequired={firstNameRequired}
            lastNameRequired={lastNameRequired}
            fileRequired={fileRequired}
            allowMultipleFiles={allowMultipleFiles}
            successMessage={successMessage}
            submitButtonText={submitButtonText}
            linkBack={linkBack}
        />
    );
};

const fieldsTab = {
    displayName: "Fields",
    sortOrder: 2,
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(TECSubmitNewForm),
    definition: {
        displayName: "TEC Contact Form",
        group: constants.widgetGroup.tecSubmitNew,
        icon: "input-pipe",
        fieldDefinitions: [
            {
                name: fields.submitButtonText,
                displayName: "Submit Button Text",
                editorTemplate: "TextField",
                fieldType: "Translatable",
                defaultValue: "Submit",
            },
            {
                name: fields.successMessage,
                displayName: "Submit Success Message",
                editorTemplate: "RichTextField",
                fieldType: "Translatable",
                defaultValue: "Thank you for your inquiry. A customer service representative will contact you shortly.",
            },
            {
                name: fields.fileImportFormat,
                displayName: "Allowed File Formats",
                fieldType: "General",
                editorTemplate: "TextField",
                tooltip: "Use comma-separated values. i.e.: .pdf, .zip",
                defaultValue: ".pdf, .zip",
            },
            {
                name: fields.allowMultipleFiles,
                displayName: "Allow Multiple Files to be Submitted",
                fieldType: "General",
                editorTemplate: "CheckboxField",
                defaultValue: false,
            },
            {
                name: fields.isFinanceCompanyDropdown,
                displayName: "Display Finance Company field as a Dropdown?",
                fieldType: "General",
                editorTemplate: "CheckboxField",
                defaultValue: true,
                tab: fieldsTab,
            },
            {
                name: "",
                editorTemplate: "HorizontalRule",
                fieldType: "General",
                defaultValue: "",
                tab: fieldsTab,
            },
            {
                name: fields.financeCompanyRequired,
                displayName: "Greif Finance Company Required",
                fieldType: "General",
                editorTemplate: "CheckboxField",
                defaultValue: true,
                tab: fieldsTab,
            },
            {
                name: fields.messageRequired,
                displayName: "Message Required",
                fieldType: "General",
                editorTemplate: "CheckboxField",
                defaultValue: false,
                tab: fieldsTab,
            },
            {
                name: fields.firstNameRequired,
                displayName: "First Name Required",
                fieldType: "General",
                editorTemplate: "CheckboxField",
                defaultValue: true,
                tab: fieldsTab,
            },
            {
                name: fields.lastNameRequired,
                displayName: "Last Name Required",
                fieldType: "General",
                editorTemplate: "CheckboxField",
                defaultValue: true,
                tab: fieldsTab,
            },
            {
                name: fields.fileRequired,
                displayName: "File Required",
                fieldType: "General",
                editorTemplate: "CheckboxField",
                defaultValue: true,
                tab: fieldsTab,
            },
        ],
        allowedContexts: ["TECSubmitNewPage" as any],
    },
};

export default widgetModule;
